
// Third party components
import React from 'react';
import PropTypes from 'prop-types';

import { Box, Divider, Link, Typography } from '@mui/material';

// Shared components
import {Button, ContainerWithCard} from '@timmons-group/shared-react-components';

import { dateFormatter } from '@timmons-group/shared-react-components/helpers';

const MapInspector = ({ features, highlight, unhighlight, clear }) => {
  const renderLine = (label, value, key) => {
    return (<Typography variant="inspector" key={key}>
      <b>{label}:</b> {value}
    </Typography>);
  }

  if (!features || !features?.length) {
    return <ContainerWithCard sx={{marginTop: '0px'}} disableGutters>
      <p>No communities identified</p>
    </ContainerWithCard>
  }

  return (
    <>
      {features?.length &&
        <ContainerWithCard sx={{marginTop:'0px'}} cardContentProps={{sx: {padding: '8px'}}} disableGutters>
          {clear &&
            <Box sx={{width:'100%', display:'flex', marginBottom: 1}}>
              <Typography variant="sectionHeader" style={{flex: 1}}>Selections</Typography>
              <Button label="Clear" size="small" color="secondary" onClick={clear} sx={{
                fontSize: '10px',
                lineHeight: '8px',
                marginTop: 0,
                marginBottom: 0,
              }}></Button>
            </Box>
          }
          <Divider />
          {features.map((feat, index) => {
            const {properties} = feat;
            const {streamid} = properties;
            const lines = [
              renderLine('Name', properties.name || 'N/A', `${streamid}-name`),
              renderLine('Type', properties.typeName || 'N/A', `${streamid}-type`),
            ];

            let onlyInactive = properties.inactiveplancount > 0;

            if (properties.activeplancount) {
              lines.push(renderLine('Active as of', dateFormatter(properties.activeasof), `${streamid}-apc`));
              onlyInactive = false;
            }

            if (properties.indevelopmentplancount) {
              lines.push(renderLine('Plan in Development as of', dateFormatter(properties.initiatedOn), `${streamid}-idpc`));
              onlyInactive = false;
            }

            if (onlyInactive) {
              lines.push(<p key={`${streamid}-p`}>Has Inactive Plan(s)</p>);
            }

            if (properties.plancount === 0) {
              lines.push(<p key={`${streamid}-p`}>Has no Plans</p>);
            }

            return (
              <React.Fragment key={streamid}>
                {index > 0 && <Divider key={`${index}-rule`} sx={{marginTop: 1}} />}
                <Box sx={{marginTop: index ? 1 : '0px'}} key={`${index}-content`}
                  onMouseEnter={() => {
                    if (highlight) {
                      highlight(feat);
                    }
                  }}
                  onMouseLeave={() => {
                    if (unhighlight) {
                      unhighlight(feat);
                    }
                  }}
                >
                  {lines}
                  <Link variant="navLink" key={`${index}-url`} href={`/pam/communityArea/${properties.streamid}`}>View Details</Link>
                </Box>
              </React.Fragment>
            )
          })}
        </ContainerWithCard>
      }
    </>
  );
}

MapInspector.propTypes = {
  features: PropTypes.array,
  highlight: PropTypes.func,
  unhighlight: PropTypes.func,
  clear: PropTypes.func,
}

export default MapInspector;